import moment from 'moment';

export default class ProductsRatingController {

    constructor (
        $filter,
        $state,
        $window,
        $timeout,
        $stateParams,
        Brand,
        Product,
        brand,
        offset,
        order,
        name,
        ratingsInfoLoader,
        ratingsInfo
    ) {
        this.translate       = $filter('translate');
        this.$state          = $state;
        this.stateParams     = $stateParams;
        this.$window         = $window;
        this.$timeout        = $timeout;
        this.Product         = Product;
        this.Brand           = Brand;
        this.brand           = brand;
        this.offset          = offset;
        this.order           = order;
        this.ratingsInfoLoader = ratingsInfoLoader;
        this.ratingsInfo       = ratingsInfo;
        this.count           = ratingsInfo.count;
        this.page            = (offset / 10) + 1;
        this.pagesNumber     = Math.floor(this.count / 10);
        this.name            = this.$state.params.name;
        this.filter          = {
            comments: 'all',
            ratings:  'all',
        };

        var buttons = [
            { label: this.translate('DETAILS'),type: 'primary',action:this.getDetails.bind(this), target:'history', toggle:'modal'}
        ];
        var icons =[
            {class:'icon-arrow-up4', action: this.changeOrderAsc.bind(this)},
            {class:'icon-arrow-down4',  action: this.changeOrderDesc.bind(this)}
        ]; 

        this.headers = [
            { key: 'photo', label: this.translate('PICTURE'), type: 'image' },
            { key: 'position', label: this.translate('POSITION'), type: 'number' },
            { key: 'ref', label: this.translate('REFERENCE'), type: 'text' },
            { key: 'name', label: this.translate('DESIGNATION'), type: 'text' },
            { key: 'color', label:this.translate('COLOR'), type: 'text' },
            { key: 'nb', label: this.translate('RATINGCOUNT'), type: 'number' },
            { key: 'avg', label: this.translate('RATINGAVG'), icon:icons, type: 'ratings-with-value' },
            { key: '', label: '',  type: 'buttons', buttons },
        ];
        
        this.ratingsInfo = this.formatNoteInfoForCustomTable(this.ratingsInfo.products);
    }

     setComments (type) {
        this.filter.comments = type;
        this.updateFilters();
    }

    setReviews (reviews) {
        this.details = reviews;
        this.updateFilters();
    }

    setRatings (type) {
        this.filter.ratings = type;
        this.updateFilters();
    }

    updateFilters () {
        this.filteredReviews = this.details.filter(detail => {
            var result = true;

            // filter comments
            result = result && (
                    this.filter.comments === 'all'
                || this.filter.comments === 'with' && !!detail.commentaires
                || this.filter.comments === 'without' && !detail.commentaires
            );

            // filter ratings
            result = result && (this.filter.ratings === 'all'|| this.filter.ratings === detail.notes);
            return result;
        });
    }


    search(mysearch) {
        this.name= mysearch? mysearch: '';
        this.$state.transitionTo(this.$state.current.name,{
            offset:0,
            order:this.order,
            name: this.name},
            {inheret:true,location:true, relative: this.$state.$current,  reloadOnSearch:true, reload:false});
    }

    changeOrderAsc() {
        this.order='asc';
        this.$state.transitionTo(this.$state.current.name, {
            offset:this.offset,
            order:this.order,
            name: this.name
        }, {inheret:true,location:true, reload: false});
    }

    getDetails(line) {
        var splits = [0,0,0,0,0];
        this.Product.ratings(line.id).then((data) => {
            var details= data.slice(0);
            details.label = line.name;
            details.avg = line.avg; 
            details.photo = line.photo;
            details.nb = line.nb;
            details.forEach((elt)=>{
                splits[elt.notes-1]++;
            }),
            details.splits=splits,
            this.details=details, 
            this.filteredReviews = this.details;
        }).catch(error =>{
            console.log(error);
        });
    }

    changeOrderDesc() {
        this.order='desc';
        this.$state.transitionTo(this.$state.current.name, {
            offset:this.offset,
            order:this.order,
            name: this.name},
            {inheret:true,location:true, reload: false});
    }

    getResultsPage(pageNumber) {
        this.page=pageNumber;
        this.offset = 10*(pageNumber-1);
        this.$state.transitionTo(this.$state.current.name, {
            offset:this.offset,
             order:this.order, 
             name: this.name
         }, {inheret:true,location:true, reload: false});
    }
  
    formatNoteInfoForCustomTable(ratingsInfoArray) {
        if(!ratingsInfoArray){
            return [];
         }
         return ratingsInfoArray
            .map(elt => ({
                ...elt,
            }));
    }
}

ProductsRatingController.$inject = [
    '$filter',
    '$state',
    '$window',
    '$timeout',
    '$stateParams',
    'Brand',
    'Product',
    'brand',
    'offset',
    'order',
    'name',
    'ratingsInfoLoader',
    'ratingsInfo'
];



// WEBPACK FOOTER //
// ./src/page/productsRating/productsRating.controller.js